import React, { useState } from "react";
import "./ProGamingDashboard.scss";

/**
 * PRO GAMING DASHBOARD - Clean, professional, actually works
 * Inspired by the actual design references shared
 */
const ProGamingDashboard: React.FC = () => {
    const [activeTab, setActiveTab] = useState("dashboard");
    const [selectedGame, setSelectedGame] = useState("valorant");

    return (
        <div className="pro-gaming-dashboard">
            {/* LEFT SIDEBAR */}
            <aside className="sidebar">
                <div className="sidebar-header">
                    <div className="logo">
                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                            <rect width="32" height="32" rx="8" fill="#7B61FF"/>
                            <path d="M16 8L20 12L16 16L12 12L16 8Z" fill="white"/>
                            <path d="M16 16L20 20L16 24L12 20L16 16Z" fill="white" opacity="0.6"/>
                        </svg>
                        <span>DEVOUR</span>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    <button
                        className={`nav-item ${activeTab === "dashboard" ? "active" : ""}`}
                        onClick={() => setActiveTab("dashboard")}
                    >
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none">
                            <rect x="3" y="3" width="8" height="8" rx="2" fill="currentColor"/>
                            <rect x="13" y="3" width="8" height="8" rx="2" fill="currentColor" opacity="0.3"/>
                            <rect x="3" y="13" width="8" height="8" rx="2" fill="currentColor" opacity="0.3"/>
                            <rect x="13" y="13" width="8" height="8" rx="2" fill="currentColor" opacity="0.3"/>
                        </svg>
                        <span>Dashboard</span>
                    </button>

                    <button
                        className={`nav-item ${activeTab === "quests" ? "active" : ""}`}
                        onClick={() => setActiveTab("quests")}
                    >
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2L14.09 8.26L21 9.27L16.45 13.97L17.82 21L12 17.77L6.18 21L7.55 13.97L3 9.27L9.91 8.26L12 2Z" fill="currentColor"/>
                        </svg>
                        <span>Quests</span>
                    </button>

                    <button className="nav-item">
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z" fill="currentColor"/>
                            <circle cx="12" cy="12" r="3" fill="currentColor"/>
                        </svg>
                        <span>Challenges</span>
                    </button>

                    <button className="nav-item">
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M12 2L2 7V12C2 16.55 4.84 20.74 9 22.23C10.11 22.57 11.05 22.57 12 22.57C12.95 22.57 13.89 22.57 15 22.23C19.16 20.74 22 16.55 22 12V7L12 2Z" fill="currentColor"/>
                        </svg>
                        <span>Guild</span>
                    </button>

                    <button className="nav-item">
                        <svg className="nav-icon" viewBox="0 0 24 24" fill="none">
                            <path d="M20 6H4C2.9 6 2 6.9 2 8V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6ZM20 18H4V8H20V18Z" fill="currentColor"/>
                            <rect x="6" y="10" width="12" height="2" fill="currentColor"/>
                            <rect x="6" y="14" width="8" height="2" fill="currentColor"/>
                        </svg>
                        <span>Inventory</span>
                    </button>
                </nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <img src="https://via.placeholder.com/40" alt="Profile" />
                        <div className="user-info">
                            <div className="user-name">DeathKiller99</div>
                            <div className="user-level">Level 42</div>
                        </div>
                    </div>
                </div>
            </aside>

            {/* MAIN CONTENT */}
            <main className="main-content">
                {/* TOP HEADER */}
                <header className="top-header">
                    <div className="header-left">
                        <h1 className="page-title">Game Dashboard</h1>
                    </div>

                    <div className="header-right">
                        <div className="currency-display">
                            <div className="currency-item">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 2L11.5 7.5L17 9L11.5 10.5L10 16L8.5 10.5L3 9L8.5 7.5L10 2Z" fill="#FFD700"/>
                                </svg>
                                <span>2,847</span>
                            </div>
                            <div className="currency-item premium">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 2L12 8L18 10L12 12L10 18L8 12L2 10L8 8L10 2Z" fill="#E91E63"/>
                                </svg>
                                <span>12</span>
                            </div>
                        </div>

                        <button className="icon-button">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10 18C11.1 18 12 17.1 12 16H8C8 17.1 8.9 18 10 18ZM16 11V7C16 4.93 14.37 3.36 12.5 2.68V2C12.5 0.83 11.67 0 10.5 0H9.5C8.33 0 7.5 0.83 7.5 2V2.68C5.64 3.36 4 4.93 4 7V11L2 13V14H18V13L16 11Z" fill="currentColor"/>
                            </svg>
                            <span className="notification-badge">3</span>
                        </button>

                        <button className="icon-button">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 3C11.66 3 13 4.34 13 6C13 7.66 11.66 9 10 9C8.34 9 7 7.66 7 6C7 4.34 8.34 3 10 3ZM10 17.2C7.5 17.2 5.29 15.92 4 14C4.03 12 8 10.9 10 10.9C11.99 10.9 15.97 12 16 14C14.71 15.92 12.5 17.2 10 17.2Z" fill="currentColor"/>
                            </svg>
                        </button>
                    </div>
                </header>

                {/* HERO SECTION */}
                <section className="hero-section">
                    <div className="hero-background">
                        <img src="https://via.placeholder.com/1200x400/6B46C1/FFFFFF?text=VALORANT" alt="Hero" />
                        <div className="hero-overlay" />
                    </div>

                    <div className="hero-content">
                        <div className="hero-info">
                            <div className="game-selector">
                                <button
                                    className={`game-tab ${selectedGame === "valorant" ? "active" : ""}`}
                                    onClick={() => setSelectedGame("valorant")}
                                >
                                    <img src="https://via.placeholder.com/32" alt="Valorant" />
                                </button>
                                <button
                                    className={`game-tab ${selectedGame === "fortnite" ? "active" : ""}`}
                                    onClick={() => setSelectedGame("fortnite")}
                                >
                                    <img src="https://via.placeholder.com/32" alt="Fortnite" />
                                </button>
                                <button
                                    className={`game-tab ${selectedGame === "cod" ? "active" : ""}`}
                                    onClick={() => setSelectedGame("cod")}
                                >
                                    <img src="https://via.placeholder.com/32" alt="COD" />
                                </button>
                            </div>

                            <div className="hero-text">
                                <h2 className="hero-title">VALORANT</h2>
                                <p className="hero-subtitle">Competitive • Tactical Shooter</p>
                            </div>

                            <button className="play-button">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M4 2L12 8L4 14V2Z" fill="white"/>
                                </svg>
                                Play Now
                            </button>
                        </div>

                        <div className="hero-stats">
                            <div className="stat-card">
                                <div className="stat-value">1.47</div>
                                <div className="stat-label">K/D Ratio</div>
                            </div>
                            <div className="stat-card">
                                <div className="stat-value">68%</div>
                                <div className="stat-label">Win Rate</div>
                            </div>
                            <div className="stat-card">
                                <div className="stat-value">Diamond 2</div>
                                <div className="stat-label">Current Rank</div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* CONTENT GRID */}
                <div className="content-grid">
                    {/* ACTIVE QUESTS */}
                    <section className="grid-section quests-section">
                        <div className="section-header">
                            <h3 className="section-title">Active Quests</h3>
                            <button className="section-action">View All</button>
                        </div>

                        <div className="quest-grid">
                            <div className="quest-card featured">
                                <div className="quest-badge">FEATURED</div>
                                <div className="quest-image">
                                    <img src="https://via.placeholder.com/300x150/FF6B6B/FFFFFF?text=SNAPPLE" alt="Quest" />
                                </div>
                                <div className="quest-content">
                                    <h4 className="quest-title">Summer Refresh Challenge</h4>
                                    <p className="quest-description">Play 5 matches while hydrated</p>
                                    <div className="quest-progress">
                                        <div className="progress-bar">
                                            <div className="progress-fill" style={{ width: "60%" }} />
                                        </div>
                                        <span className="progress-text">3/5</span>
                                    </div>
                                    <div className="quest-rewards">
                                        <span className="reward-item">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 1L9.5 6.5L15 8L9.5 9.5L8 15L6.5 9.5L1 8L6.5 6.5L8 1Z" fill="#FFD700"/>
                                            </svg>
                                            500 XP
                                        </span>
                                        <span className="reward-item">Mystery Box</span>
                                    </div>
                                </div>
                            </div>

                            <div className="quest-card">
                                <div className="quest-timer">23:47:16</div>
                                <div className="quest-image mini">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <circle cx="20" cy="20" r="20" fill="#7B61FF"/>
                                        <path d="M20 10L22 18L30 20L22 22L20 30L18 22L10 20L18 18L20 10Z" fill="white"/>
                                    </svg>
                                </div>
                                <div className="quest-content">
                                    <h4 className="quest-title">Daily Login</h4>
                                    <p className="quest-description">Log in for 7 days</p>
                                    <div className="quest-rewards">
                                        <span className="reward-item">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 1L9.5 6.5L15 8L9.5 9.5L8 15L6.5 9.5L1 8L6.5 6.5L8 1Z" fill="#FFD700"/>
                                            </svg>
                                            100
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div className="quest-card">
                                <div className="quest-image mini">
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                                        <circle cx="20" cy="20" r="20" fill="#4ECDC4"/>
                                        <path d="M20 12V28M12 20H28" stroke="white" strokeWidth="3" strokeLinecap="round"/>
                                    </svg>
                                </div>
                                <div className="quest-content">
                                    <h4 className="quest-title">First Blood</h4>
                                    <p className="quest-description">Get first kill 3 times</p>
                                    <div className="quest-rewards">
                                        <span className="reward-item">
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                <path d="M8 2L10 8L16 10L10 12L8 18L6 12L0 10L6 8L8 2Z" fill="#E91E63"/>
                                            </svg>
                                            1
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* STATS OVERVIEW */}
                    <section className="grid-section stats-section">
                        <div className="section-header">
                            <h3 className="section-title">Performance</h3>
                        </div>

                        <div className="stats-content">
                            <div className="radar-chart">
                                <svg viewBox="0 0 200 200">
                                    {/* Grid */}
                                    <polygon points="100,30 170,65 170,135 100,170 30,135 30,65"
                                        fill="none" stroke="#333" strokeWidth="1"/>
                                    <polygon points="100,50 150,75 150,125 100,150 50,125 50,75"
                                        fill="none" stroke="#333" strokeWidth="1"/>
                                    <polygon points="100,70 130,85 130,115 100,130 70,115 70,85"
                                        fill="none" stroke="#333" strokeWidth="1"/>

                                    {/* Data */}
                                    <polygon points="100,40 160,80 140,130 100,140 60,120 70,70"
                                        fill="rgba(123,97,255,0.3)" stroke="#7B61FF" strokeWidth="2"/>

                                    {/* Labels */}
                                    <text x="100" y="20" textAnchor="middle" fill="#999" fontSize="12">AIM</text>
                                    <text x="180" y="70" textAnchor="start" fill="#999" fontSize="12">GAME IQ</text>
                                    <text x="180" y="140" textAnchor="start" fill="#999" fontSize="12">SURVIVAL</text>
                                    <text x="100" y="185" textAnchor="middle" fill="#999" fontSize="12">TEAMWORK</text>
                                    <text x="20" y="140" textAnchor="end" fill="#999" fontSize="12">AGGRO</text>
                                    <text x="20" y="70" textAnchor="end" fill="#999" fontSize="12">CLUTCH</text>
                                </svg>
                            </div>

                            <div className="stats-list">
                                <div className="stat-item">
                                    <span className="stat-name">Headshot %</span>
                                    <span className="stat-value">24.5%</span>
                                </div>
                                <div className="stat-item">
                                    <span className="stat-name">Avg Score</span>
                                    <span className="stat-value">267</span>
                                </div>
                                <div className="stat-item">
                                    <span className="stat-name">Win Streak</span>
                                    <span className="stat-value">4</span>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* LEADERBOARD */}
                    <section className="grid-section leaderboard-section">
                        <div className="section-header">
                            <h3 className="section-title">Guild Leaderboard</h3>
                            <div className="section-tabs">
                                <button className="tab active">Daily</button>
                                <button className="tab">Weekly</button>
                                <button className="tab">All Time</button>
                            </div>
                        </div>

                        <div className="leaderboard-list">
                            <div className="leaderboard-item">
                                <span className="rank">1</span>
                                <img src="https://via.placeholder.com/32" alt="Player" className="player-avatar" />
                                <div className="player-info">
                                    <div className="player-name">xKiller99</div>
                                    <div className="player-guild">FaZe Clan</div>
                                </div>
                                <div className="player-score">12,450 XP</div>
                            </div>

                            <div className="leaderboard-item">
                                <span className="rank">2</span>
                                <img src="https://via.placeholder.com/32" alt="Player" className="player-avatar" />
                                <div className="player-info">
                                    <div className="player-name">Phoenix</div>
                                    <div className="player-guild">100 Thieves</div>
                                </div>
                                <div className="player-score">11,230 XP</div>
                            </div>

                            <div className="leaderboard-item">
                                <span className="rank">3</span>
                                <img src="https://via.placeholder.com/32" alt="Player" className="player-avatar" />
                                <div className="player-info">
                                    <div className="player-name">Ninja</div>
                                    <div className="player-guild">Team Liquid</div>
                                </div>
                                <div className="player-score">10,890 XP</div>
                            </div>

                            <div className="leaderboard-item you">
                                <span className="rank">42</span>
                                <img src="https://via.placeholder.com/32" alt="You" className="player-avatar" />
                                <div className="player-info">
                                    <div className="player-name">DeathKiller99</div>
                                    <div className="player-guild">Apex Predators</div>
                                </div>
                                <div className="player-score">4,235 XP</div>
                            </div>
                        </div>
                    </section>
                </div>
            </main>

            {/* RIGHT PANEL */}
            <aside className="right-panel">
                <div className="panel-section">
                    <h4 className="panel-title">Squad Online</h4>
                    <div className="squad-list">
                        <div className="squad-member">
                            <img src="https://via.placeholder.com/32" alt="Member" />
                            <div className="member-info">
                                <div className="member-name">Shadow</div>
                                <div className="member-status online">In Game</div>
                            </div>
                            <button className="invite-btn">+</button>
                        </div>
                        <div className="squad-member">
                            <img src="https://via.placeholder.com/32" alt="Member" />
                            <div className="member-info">
                                <div className="member-name">Ghost</div>
                                <div className="member-status online">Online</div>
                            </div>
                            <button className="invite-btn">+</button>
                        </div>
                        <div className="squad-member">
                            <img src="https://via.placeholder.com/32" alt="Member" />
                            <div className="member-info">
                                <div className="member-name">Reaper</div>
                                <div className="member-status offline">Offline</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="panel-section">
                    <h4 className="panel-title">Upcoming Events</h4>
                    <div className="event-card">
                        <div className="event-time">
                            <div className="time-value">2H</div>
                            <div className="time-label">LEFT</div>
                        </div>
                        <div className="event-info">
                            <div className="event-name">Guild War</div>
                            <div className="event-desc">vs Shadow Legion</div>
                        </div>
                    </div>
                    <div className="event-card">
                        <div className="event-time">
                            <div className="time-value">5H</div>
                            <div className="time-label">LEFT</div>
                        </div>
                        <div className="event-info">
                            <div className="event-name">Flash Quest</div>
                            <div className="event-desc">Double XP Event</div>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    );
};

export default ProGamingDashboard;